import {authHeader} from '@/helpers';

export default function (instance) {
    return {
        getGalleryById(caseId, clientId, galleryId) {
            return instance.get(`/gallery/case/${caseId}/user/${clientId}/gallery/${galleryId}`);
        },

        getGalleryListFiles(caseId, clientId, params) {
            return instance.get(`/gallery/case/${caseId}/user/${clientId}`, {params});
        },
        exportGallery(caseId, format, idsList) {
            return fetch(`${process.env.VUE_APP_API}/api/v1/cases/${caseId}/export/gallery?format=${format}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                },
                body: JSON.stringify(idsList),
            });
        },
        getListTags(caseId) {
            return instance.get(`/galleryTag/case/${caseId}`);
        },
        addNewCategory(caseId, data) {
            return instance.post(`/galleryTag/case/${caseId}/category`, data);
        },
        addTagToGallery(caseId, galleryId, tagId) {
            return instance.post(`galleryTag/${caseId}/gallery/${galleryId}/tag/${tagId}`, {});
        },

        removeTagFromGallery(caseId, galleryId, tagId) {
            return instance.delete(`galleryTag/${caseId}/gallery/${galleryId}/tag/${tagId}`);
        },

        getListTagsByClientId(caseId, clientId) {
            return instance.get(`galleryTag/case/${caseId}/chat/${clientId}`);
        },

        addNewTag(caseId, categoryId, data) {
            return instance.post(`galleryTag/case/${caseId}`, data, {params: {categoryId}});
        },

        editTag(caseId, tagId, data) {
            return instance.put(`galleryTag/case/${caseId}/tag/${tagId}`, data);
        },

        editCategory(caseId, categoryId, data) {
            return instance.put(`galleryTag/case/${caseId}/category/${categoryId}`, data);
        },

        getListTagsForGallery(galleryId, caseId) {
            return instance.get(`galleryTag/${galleryId}/case/${caseId}/tags`);
        },

        removeTag(caseId, tagId) {
            return instance.delete(`galleryTag/${tagId}/case/${caseId}`);
        },

        removeCategory(caseId, categoryId) {
            return instance.delete(`galleryTag/case/${caseId}/category/${categoryId}`);
        },

        changeTagOrder(caseId, data) {
            return instance.post(`galleryTag/case/${caseId}/order`, data);
        },

        changeCategoryOrder(caseId, data) {
            return instance.post(`galleryTag/case/${caseId}/category/order`, data);
        },

        getListGalleryFiles(caseId, clientId, {
            page = 1,
            size = 20,
            deviceId,
            tagsOnly = false,
            tagSearch,
            pinnedOnly = false
        } = {}) {
            return instance.get(
                `gallery/case/${caseId}/user/${clientId}`,
                {params: {page, size, deviceId, tagsOnly, tagSearch, pinnedOnly}}
            );
        },

        getClientsAndDevicesList(caseId, {
            sortBy = 'userName',
            keySearch,
            order = 'desc',
            page = 1,
            size = 20
        } = {}) {
            return instance.get(
                `gallery/case/${caseId}/clients`,
                {params: {sortBy, keySearch, order, page, size}}
            );
        },

        createComment(caseId, galleryId, commentRequest) {
            return instance.post(`gallery/${caseId}/gallery/${galleryId}/comment`, commentRequest);
        },

        editComment(caseId, commentId, commentRequest) {
            return instance.put(`gallery/${caseId}/comment/${commentId}`, commentRequest);
        },

        deleteComment(caseId, commentId) {
            return instance.delete(`gallery/${caseId}/comment/${commentId}`);
        },

        getListComments(caseId, galleryId) {
            return instance.get(`gallery/${caseId}/gallery/${galleryId}/comments`);
        },

        getListCommentsByClientId(caseId, clientId, {
            searchKey,
            page = 1,
            size = 20
        } = {}) {
            return instance.get(
                `gallery/${caseId}/client/${clientId}/comments`,
                {params: {searchKey, page, size}}
            );
        },

        blurGallery(caseId, galleryId) {
            return instance.put(`gallery/${galleryId}/case/${caseId}/blur`, {});
        },

        unBlurGallery(caseId, galleryId) {
            return instance.put(`gallery/${galleryId}/case/${caseId}/unblur`, {});
        },

        showBluredGallery(caseId, galleryId) {
            return instance.get(`gallery/${galleryId}/case/${caseId}/blur`, {});
        },

        pinGallery(caseId, galleryIds) {
            return instance.post(`gallery/case/${caseId}/pin`, {galleryId: galleryIds});
        },

        unPinGallery(caseId, galleryIds) {
            return instance.post(`gallery/case/${caseId}/unpin`, {galleryId: galleryIds});
        },

        getGalleryData({caseId, galleryId}) {
            return instance.get(`/gallery/case/${caseId}/gallery/${galleryId}/metadata`);
        },

        // exportGallery(caseId, format, idsList) {
        //     return fetch(`${process.env.VUE_APP_API}/api/v1/cases/${caseId}/export/gallery?format=${format}`, {
        //         method: 'POST',
        //         headers: {
        //             'Authorization': authHeader(),
        //         },
        //         body: idsList
        //     })
        // },
    };
}